import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentPlus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.25 21.25h-3.5a3 3 0 0 1-3-3V5.75a3 3 0 0 1 3-3h8.5a3 3 0 0 1 3 3v6.5m-2 3v3m0 0v3m0-3h-3m3 0h3M8.75 6.75h6.5m-6.5 4h2.5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentPlus);
export default ForwardRef;
